import { Button, Header, LoadingSpinner, TextInput } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { API_URL } from '@constants/apiUrl'
import { cx } from '@/utils/cx'
import { AmexGreatLayout } from './AmexGreatLayout'

export const UserDataAmexGreatPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { currentScenarioId, context } = store.ScenarioState
  const { userDataPage: trans } = store.TranslationsState.translations

  const [emailInputValue, setEmailInputValue] = useState('')
  const [phoneInputValue, setPhoneInputValue] = useState('')
  const [validationErrorEmail, setValidationErrorEmail] = useState(false)
  const [validationErrorPhone, setValidationErrorPhone] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)

  const shouldAskForEmail = !!context?.shouldAskForEmail
  const shouldAskForPhoneNumber = !!context?.shouldAskForPhoneNumber

  const handleProceed = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    if (currentScenarioId !== 'localTests') {
      setBtnLoading(true)

      let output: {
        email?: string
        phoneNumber?: string
      } = {}

      if (shouldAskForEmail) {
        output = {
          email: emailInputValue,
        }
      }

      if (shouldAskForPhoneNumber) {
        output = {
          phoneNumber: phoneInputValue.replace(/\s+/g, ''),
        }
      }

      if (shouldAskForEmail && shouldAskForPhoneNumber) {
        output = {
          email: emailInputValue,
          phoneNumber: phoneInputValue.replace(/\s+/g, ''),
        }
      }

      await axiosInstance.post(`${API_URL}/electronic-id/update-contact-data`, output, {
        withCredentials: true,
      })
      setBtnLoading(false)
    }

    store.ScenarioState.nextPage()
  }

  function getDisabledState() {
    let output = true

    if (shouldAskForEmail && shouldAskForPhoneNumber) {
      if (
        emailInputValue.length &&
        phoneInputValue.length &&
        !validationErrorEmail &&
        !validationErrorPhone
      ) {
        output = false
      }
    } else if (shouldAskForEmail && !shouldAskForPhoneNumber) {
      if (emailInputValue.length && !validationErrorEmail) {
        output = false
      }
    } else if (shouldAskForPhoneNumber && !shouldAskForEmail) {
      if (phoneInputValue.length && !validationErrorPhone) {
        output = false
      }
    }

    return output
  }

  useEffect(() => {
    if (!shouldAskForEmail && !shouldAskForPhoneNumber) {
      store.ScenarioState.skipStep()
    }
  }, [shouldAskForEmail, shouldAskForPhoneNumber])

  if (!shouldAskForEmail && !shouldAskForPhoneNumber) {
    return (
      <AmexGreatLayout>
        <div className="page-container">
          <LoadingSpinner />
        </div>
      </AmexGreatLayout>
    )
  }

  return (
    <AmexGreatLayout>
      <div className="page-container">
        <form onSubmit={(e) => handleProceed(e)}>
          <Header>{trans.header}</Header>
          <div>
            {shouldAskForEmail ? (
              <div className="generic__input-container">
                <div className="generic__label">{trans.email}</div>
                <TextInput
                  type="email"
                  value={emailInputValue}
                  onChange={(value) => {
                    setEmailInputValue(value)
                  }}
                  onError={(e) => setValidationErrorEmail(e)}
                  id="email-input"
                  autoComplete="email"
                  emailErrorLabel={trans.emailErrorLabel}
                  requiredErrorLabel={trans.requiredErrorLabel}
                />
              </div>
            ) : (
              <></>
            )}
            {shouldAskForPhoneNumber ? (
              <div className="generic__input-container">
                <div className="generic__label">{trans.phone}</div>
                <TextInput
                  type="phone"
                  value={phoneInputValue}
                  onChange={(value) => {
                    setPhoneInputValue(value)
                  }}
                  onError={(e) => setValidationErrorPhone(e)}
                  id="phone-input"
                  autoComplete="tel"
                  phoneErrorLabel={trans.phoneErrorLabel}
                  requiredErrorLabel={trans.requiredErrorLabel}
                />
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className="layout__content-container-bottom-fixed">
            {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}
            <Button
              onClick={(e) => handleProceed(e)}
              disabled={getDisabledState()}
              className="button--w164"
              id="page-submit"
              type="submit"
            >
              {btnLoading && <LoadingSpinner inButton />}
              <span
                className={cx(
                  'generic__button-text',
                  btnLoading && 'generic__button-text--loading'
                )}
              >
                {trans.proceed}
              </span>
            </Button>
          </div>

          <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
        </form>
      </div>
    </AmexGreatLayout>
  )
})
